import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

import { usePollDays } from 'components/overview/Overview';
import { Pagesection, Tabs, TabsPanel, Teaser } from '@ktag/styleguide/dist/react';

const Archive = () => {
  const { query } = usePollDays();
  const { t } = useTranslation('wap');
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Pagesection>
        <Tabs noBezel>
          <TabsPanel
            label={t('dates')}
            hash="/archiv"
            initialActive={pathname === '/archiv'}
            id="dates"
          />
          <TabsPanel
            label={t('issues')}
            hash="/archiv/vorlagen"
            initialActive={pathname === '/archiv/vorlagen'}
            id="issues"
          />
        </Tabs>
      </Pagesection>
      <Outlet context={{ query }} />
      <Pagesection type="slender">
        <Teaser
          title={t('teaser_data_portal_title')}
          description={t('teaser_data_portal_description')}
          url={t('statistics_portal_url')}
          external
        />
      </Pagesection>
    </>
  );
};

export default Archive;
